import glamorous from 'glamorous';

import { media } from '../../../styles';

const NavLeft = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 0,
  flexShrink: 0,

  [media('sm', { isMax: true })]: {
    paddingLeft: 40, // MenuIconButton.width - Nav.paddingLeft
  },

  [media('sm')]: {
    '& .MenuIconButton': {
      display: 'none',
    },
  },
});

export default NavLeft;



// WEBPACK FOOTER //
// ./src/components/layout/Nav/NavLeft.js